import React, { Component } from 'react';
import './CardHeader.css';
import Label from '../label/Label';

export default class CardHeader extends Component {
	render() {
		return (
			
				<Label isHeader="true" black larger className={'g-card-header ' + (this.props.className || '')}>
				{this.props.children}
				</Label>
			
			
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/cardHeader/CardHeader.jsx